import { api } from './auth.service';

// ════════════════════════════════════════════════════════════════════════════
// tarefaAnexo.service.js — anexos DA TAREFA (r199)
// ────────────────────────────────────────────────────────────────────────────
// Diferente do comentario.service (anexo dentro do comentário), aqui o arquivo
// fica pendurado na tarefa e aparece como ícone no cabeçalho do modal.
//
// Download/visualização passa por aqui (e não por <a href>) de propósito: a
// rota é protegida pela permissão de tarefas e só o axios injeta o
// x-usuario-id que o middleware exige.
// ════════════════════════════════════════════════════════════════════════════

const tarefaAnexoService = {

  listar: async (tarefaId) => {
    const res = await api.get(`/tarefas/${tarefaId}/arquivos`);
    return res.data;
  },

  // Upload com descrição (o tooltip do ícone). Descrição vazia → backend usa
  // o nome do arquivo.
  upload: async (tarefaId, file, descricao, onProgress) => {
    const form = new FormData();
    form.append('arquivo', file);
    form.append('descricao', descricao || '');
    const res = await api.post(`/tarefas/${tarefaId}/arquivos`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (evt) => {
        if (onProgress && evt.total) onProgress(Math.round((evt.loaded * 100) / evt.total));
      },
    });
    return res.data;
  },

  // Edita só a descrição
  atualizarDescricao: async (tarefaId, anexoId, descricao) => {
    const res = await api.put(`/tarefas/${tarefaId}/arquivos/${anexoId}`, { descricao });
    return res.data;
  },

  excluir: async (tarefaId, anexoId) => {
    const res = await api.delete(`/tarefas/${tarefaId}/arquivos/${anexoId}`);
    return res.data;
  },

  // Busca o arquivo como blob (com o header de permissão) e devolve uma URL
  // local. Quem chama decide: abrir em aba nova ou disparar download.
  // Lembre de dar URL.revokeObjectURL depois.
  blobUrl: async (tarefaId, anexoId, mime) => {
    const res = await api.get(`/tarefas/${tarefaId}/arquivos/${anexoId}/download`, {
      responseType: 'blob',
    });
    return URL.createObjectURL(new Blob([res.data], { type: mime || res.data.type }));
  },

  // Abre imagem/PDF em aba nova; qualquer outro formato (inclusive zip/rar)
  // vira download com o nome original.
  abrir: async (anexo) => {
    const url = await tarefaAnexoService.blobUrl(anexo.tarefa_id, anexo.id, anexo.mime);
    const mime = anexo.mime || '';
    const podeVisualizar = mime.startsWith('image/') || mime === 'application/pdf';

    if (podeVisualizar) {
      window.open(url, '_blank', 'noopener');
      // Revoga só depois que a aba carregou — revogar na hora quebra a aba.
      setTimeout(() => URL.revokeObjectURL(url), 60000);
      return;
    }

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', anexo.nome_original || 'arquivo');
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  },
};

export default tarefaAnexoService;
